import React from 'react';
import type { PointKind } from '../../data/joystick-mock';

interface RouteThumbProps {
  points: Array<{ x: number; y: number; kind: PointKind }>;
  activeIndex?: number;
  className?: string;
}

/** Tiny route sketch used on session cards and timeline rows. */
const RouteThumb: React.FC<RouteThumbProps> = ({ points, activeIndex, className = '' }) => {
  const route = points
    .map((point, index) => `${index === 0 ? 'M' : 'L'} ${point.x.toFixed(1)} ${point.y.toFixed(1)}`)
    .join(' ');

  return (
    <svg className={`js-thumb ${className}`.trim()} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <rect className="js-thumb__bg" width="100" height="100" />
      <path className="js-thumb__lane" d="M8 28H92M8 58H92M8 82H92M22 8V92M52 8V92M78 8V92" />
      <ellipse className="js-thumb__park" cx="30" cy="40" rx="12" ry="8" />
      {route && <path className="js-thumb__route" d={route} />}
      {points.map((point, index) => (
        <circle
          key={`${point.kind}-${index}`}
          cx={point.x}
          cy={point.y}
          r={activeIndex === index ? 5.2 : 3.4}
          className={`js-thumb__pt js-thumb__pt--${point.kind}${activeIndex === index ? ' is-active' : ''}`}
        />
      ))}
    </svg>
  );
};

export default RouteThumb;
